import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../SigninScreen.css";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";
import { getError, loginHandler } from "../utils";

export default function SigninScreen() {
  const Axios = useAxios();
  const navigate = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/";

  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [formValidated, setFormValidated] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);
  const [isPhoneLogin, setIsPhoneLogin] = useState(false);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  const submitHandler = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFormValidated(true);

      if (isPhoneLogin && phone.length < 10) {
        setPhoneValid(false);
      }
      return;
    }

    if (isPhoneLogin && phone.length < 10) {
      setPhoneValid(false);
      return;
    }

    try {
      const { data } = isPhoneLogin
        ? await Axios.post("/api/busers/signin", {
            phone: "+" + phone,
            password,
          })
        : await Axios.post("/api/busers/signin", {
            email,
            password,
          });
      loginHandler(data, ctxDispatch, localStorage);
      navigate(redirect ? redirect : "/");
    } catch (err) {
      toast.error(getError(err));
    }
  };

  return (
    <Container className="signin-small-container">
      <Helmet>
        <title>Kolay Cafe Giriş</title>
      </Helmet>
      <div className="signin-form-header">
        <h1>Kolay Cafe</h1>
      </div>
      <Form
        onSubmit={submitHandler}
        noValidate
        validated={formValidated}
        className="signin-signin-form"
      >
        {isPhoneLogin ? (
          <Form.Group className="signin-form-group">
            <Form.Label>Telefon</Form.Label>
            <PhoneInput
              country={"tr"}
              onlyCountries={["tr"]}
              countryCodeEditable={false}
              value={phone}
              onChange={(p) => {
                setPhone(p);
                setPhoneValid(true);
              }}
              inputClass="signin-form-control  signin-phone-input form-control"
              inputStyle={{ width: "100%", height: "55px" }}
              buttonStyle={{
                borderTopLeftRadius: "30px",
                borderBottomLeftRadius: "30px",
              }}
              inputProps={{
                name: "Telefon",
              }}
              isValid={(value, country) => {
                if (!phoneValid) {
                  return "Hatalı telefon numarası";
                }
                return true;
              }}
            />
          </Form.Group>
        ) : (
          <Form.Group className="mb-3">
            <Form.Label>E-posta Adresiniz</Form.Label>
            <div className="input-icon-wrapper">
              <i className="fas fa-envelope"></i>
              <Form.Control
                className="signin-form-control with-icon"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              />

              <Form.Control.Feedback type="invalid">
                Lütfen geçerli bir e-posta adresi giriniz
              </Form.Control.Feedback>
            </div>
          </Form.Group>
        )}

        <Form.Group className="signin-form-group">
          <Form.Label>Şifre</Form.Label>
          <div className="input-icon-wrapper">
            <i className="fas fa-lock"></i>
            <Form.Control
              type="password"
              required
              onChange={(e) => setPassword(e.target.value)}
              className="signin-form-control with-icon"
            />

            <Form.Control.Feedback type="invalid">
              Lütfen şifrenizi giriniz.
            </Form.Control.Feedback>
          </div>
        </Form.Group>
        <div className="signin-button-group">
          <Button
            type="submit"
            className="signin-submit-button"
            variant="light"
          >
            <i className="fas fa-arrow-right"></i>
            Giriş Yap
          </Button>
        </div>
        <div className="signin-link-group">
          Hesabınız yok mu?{" "}
          <Link
            to={`/signup?redirect=${redirect}`}
            className="signin-signup-link"
          >
            Hesap oluştur
          </Link>
        </div>
        {false && (
          <div className="signin-link-group">
            {isPhoneLogin ? (
              <Link
                to=""
                onClick={() => setIsPhoneLogin(false)}
                className="signin-toggle-login-link"
              >
                <i className="fa fa-user"></i>{" "}
                <span>Kullanıcı adı ile giriş yapmak için</span>{" "}
                <span className="signin-underline-text">tıklayınız</span>
              </Link>
            ) : (
              <Link
                to=""
                onClick={() => setIsPhoneLogin(true)}
                className="signin-toggle-login-link"
              >
                <i className="fas fa-mobile-alt"></i>{" "}
                <span>Telefon no ile giriş yapmak için </span>{" "}
                <span className="signin-underline-text">tıklayınız</span>
              </Link>
            )}
          </div>
        )}

        <div className="signin-link-group">
          <Link
            to={`/newpassword?redirect=${redirect}`}
            className="signin-toggle-login-link"
          >
            <span className="signin-underline-text">Şifremi unuttum!</span>{" "}
          </Link>
        </div>
      </Form>
    </Container>
  );
}
